export const blockDevTools = (env: string) => {
    if (env != undefined && env !== 'development') {
        document.addEventListener("contextmenu", (event) => event.preventDefault());
        document.addEventListener("keydown", (event) => {
            if (
                event.key === "F12" ||
                (event.ctrlKey && event.shiftKey && event.key === "I") ||
                (event.ctrlKey && event.shiftKey && event.key === "J") ||
                (event.ctrlKey && event.key === "U")
            ) {
                event.preventDefault();
            }
        });
        console.log = console.error = console.warn = () => { };
    }
}